import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/common/state/hooks";
import type { ILanguage } from "../state/languagesSlice";
import { getAllLanguages } from "../state/languagesSlice";

export const prettyLanguageName = (
  languageId: number,
  languages: ILanguage[],
  t: TFunction,
): string => {
  const lang = languages.find((l) => l.id === Number(languageId));
  if (lang?.IETF_BCP_47) {
    const key = `general.languages.IETF_BCP_47.${lang.IETF_BCP_47}`;
    const translated = t(key);
    if (translated && translated !== key) return translated;
  }
  if (lang?.name) return lang.name;
  return `#${languageId}`;
};

export const usePrettyLanguageName = () => {
  const { t } = useTranslation();
  const languages = useAppSelector(getAllLanguages);
  return (languageId: number): string => prettyLanguageName(languageId, languages, t);
};
